import React from 'react'

import classNames from 'classnames/dedupe'

import { type PaperSizes } from 'components/atoms/Paper'

import './Sticky.css'

type StickyProps = {
  children: React.ReactNode
  top?: boolean | ArrayElement<typeof PaperSizes>
  bottom?: boolean | ArrayElement<typeof PaperSizes>
  clickThrough?: boolean
  center?: boolean
  marginTop?: ArrayElement<typeof PaperSizes>
  zIndex?: number
}

const Sticky = ({ children, top, bottom, marginTop, zIndex, clickThrough, center }: StickyProps): JSX.Element => {
  const classes = classNames('Sticky', {
    Sticky_top: top,
    Sticky_bottom: bottom,
    Sticky_clickThrough: clickThrough,
    Sticky_center: center,
  })

  return (
    <div
      className={classes}
      style={{
        // @ts-expect-error: the custom properties are valid properties for the style object
        '--sticky-top': typeof top === 'number' && `${top}px`,
        '--sticky-bottom': typeof bottom === 'number' && `${bottom}px`,
        '--sticky-margin-top': marginTop && `${marginTop}px`,
        '--sticky-z-index': zIndex,
      }}
    >
      {children}
    </div>
  )
}

export { Sticky }
